import { useForm, Controller } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  createNewSite,
  updateSite,
//  editSiteSn,
  clearSubmitSiteError,
  selectSitesState,
  modifySite,
} from '../../redux/slices/sitesSlice';
import { format, set } from 'date-fns';
import { ContactPayload, EquipementState, SitePayload, SiteState } from '../../redux/types';
import { getPiscineInfos, piscineFields, getSDetailRegister, getClimInfos, getVentilInfos, getEcsInfos, getChauffInfos, chauffFields, ecsFields, climFields, getPlaquesInfos, getFourInfos, plaquesFields, fourFields, ventilFields } from '../../types/siteDetailsInfos';
import ErrorBox from '../../components/ErrorBox';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import IconDashboard from '@material-ui/icons/Dashboard';
import InfoIcon from '@material-ui/icons/Info';

import {
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  InputAdornment,
  FormLabel,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  InputLabel,
  MenuItem,
  Select,
  OutlinedInput,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Divider,
  Paper,
  Checkbox,
  FormGroup,
  Link,
} from '@material-ui/core';
import { useFormStyles, useMainPageStyles, useTableStyles } from '../../styles/muiStyles';
import DateIcon from '@material-ui/icons/DateRangeTwoTone';
import SubjectIcon from '@material-ui/icons/Subject';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { MultiSelectTreeViewProps } from '@material-ui/lab';
import { SelectProps } from '@material-ui/core';
import AppMenu from '../../components/AppMenu';
import { MultiSelect } from "react-multi-select-component";
import { createContact, updateContact } from '../../redux/slices/contactsSlice';
import { autoLogin } from '../../redux/slices/authSlice';
import { fetchConcentrateursForSiteSn } from '../../redux/slices/concentrateursSlice';
import { fetchEquipementsBySitesSn, fetchEquipementsForSiteSn, selectEquipementsState } from '../../redux/slices/equipementsSlice';
import { arrayIncludes } from '@material-ui/pickers/_helpers/utils';
import usages from '../../services/usages';
import postes from '../../services/postes';
import { selectUsagesState } from '../../redux/slices/usagesSlice';
import { selectPostesState } from '../../redux/slices/postesSlice';
import { CheckBox } from '@material-ui/icons';
/*import { Dropdown } from 'react-nested-dropdown';
import { ChauffageSelector } from '../../components/ChauffageSelector';*/

const validationSchema = yup.object({
  site_sn: yup
    .string()
    .required('Required')
    .min(3, 'Must be at least 3 characters')
    .max(60, 'Must be at most 60 characters'),

  cpt_type: yup.string().required('Required'),
});

export type occupationProps = {
  siteId: string;
  range: string;
  nombre: number;
  taux: number;
}
type statsOccup = {
  [key:string]: occupationProps[];
}

interface DataExportProps {
  closeDialog?: () => void;
  isEditMode: boolean;
  isMobile: boolean;
}

const DataExport: React.FC<DataExportProps> = ({
  closeDialog,
  isEditMode,
  isMobile,
}) => {
  const classes = useFormStyles();
  const classes3 = useMainPageStyles();
  const classes2 = useTableStyles();
  const dispatch = useDispatch();
  const { submitError, submitLoading } = useSelector(selectSitesState);

  const { usages } = useSelector(selectUsagesState)
  const { postes } = useSelector(selectPostesState)

  function UsagesExport() {  
    let initialPostes: Array<{id: number, name: string, intermediate: boolean, selected: boolean}> = []
    //initialPostes.push({id: 0, name: "", selected: false})
    postes.map((p,index)=>
        initialPostes.push({id: Number(p.id), name: p.name, intermediate: false, selected: true})
    )
    let initialUsages: Array<{id: number, name: string, id_poste: number, selected: boolean}> = []
    //initialUsages.push({id: 0, name: "", id_poste: 0, selected: false})
    usages.map((p,index)=>
        initialUsages.push({id: Number(p.id), name: p.name, id_poste: p.id_poste, selected: true})
    )
    const { register, control, handleSubmit, errors } = useForm({
      mode: 'onChange', // onSubmit
      defaultValues:
      {
    
      },
    });
    const [state, setState] = useState({
        date_start: Date.now(),
        date_end: Date.now()
    })
    const [lespostes, setlesPostes] = useState(initialPostes);
    const [lesusages, setlesUsages] = useState(initialUsages);
    
    function posteChkboxHandler(event: React.ChangeEvent<{}>) {
        const evt = event as ChangeEvent<HTMLInputElement>
        setlesPostes({
            ...lespostes,
            [evt.target.name]: evt.target.checked
        })
/*        if( evt.target.name === "dbleSuivi") { 
            if(evt.target.checked === true ) { setSelectedVoieScenario("chgmtvoie"); setDbleSuivi(evt.target.checked); setDelDevice(!evt.target.checked) }
            else { setDbleSuivi(false); setDelDevice(false) }
        }
        if( evt.target.name === "delDevice") { 
            if(evt.target.checked === true ) { setSelectedVoieScenario("endvoie"); setDelDevice(evt.target.checked); setDbleSuivi(!evt.target.checked) }
            else { setDbleSuivi(false); setDelDevice(false) } 
        }
        console.log("######## new chkBox target/value: "+evt.target.name+" / "+evt.target.checked+" | @@@@@@@@@@@@@ selectedVoieScenario ["+selectedVoieScenario+"]")
        console.log("######## dbleSuivi STATE: "+dbleSuivi+" | ######### delDevice STATE: "+delDevice)*/
    }
/*    const selectChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
      console.log("################ e.taget.value: "+event.target.value)
      setState({ ...state, [event.target.name as string]: event.target.value })
//      setSelected(event.target.value as String)
    }*/
    function handleDateChg(evt: { target: { value: any; name: any; }; }) {
      console.log("handleDateChg: "+evt.target.name+" "+evt.target.value);
      const value = evt.target.value;
      setState({ ...state, [evt.target.name]: value });
    }

    const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
      console.log(data)
      console.log(lespostes)
//      dispatch(createNewSite( theContact, logement, closeDialog ))
    });
    function handlePosteClick(event: React.ChangeEvent<{}>) {
        const evt = event as ChangeEvent<HTMLInputElement>
        const theId = Number(evt.target.name.replace("poste_",""))-1
        const wasChecked = lespostes.find(p => p.id === theId)?.selected
        console.log("Poste previously checked ? = "+wasChecked+" Poste ID: "+theId)
        const nextUsages = lesusages.map(usage => {
            if (usage.id_poste === theId) {
                /*console.log("usage->poste MATCH: "+usage.name)*/
                return { ...usage, selected: wasChecked ? false : true };
//                return { ...usage, selected: !!!lespostes.find(poste => poste.id === theId)?.selected || true };
            } else { /*console.log("usage du poste PAS TROUVÉ");*/ return usage; }
        });
        setlesUsages(nextUsages);
        const nextPostes = lespostes.map(poste => {
            if (poste.id === theId) {
                console.log("poste trouvé: "+theId+" "+poste.id+" "+poste.name)
                return { ...poste, selected: !!!poste.selected, intermediate: false };
                //return { ...poste, selected: !!!poste.selected/*, intermediate: !!checkUsagesChk(theId)*/ };
            } else { return poste; }
        });
        setlesPostes(nextPostes);
    }
    function handleUsageClick(event: React.ChangeEvent<{}>) {
        const evt = event as ChangeEvent<HTMLInputElement>
        const theId = Number(evt.target.name.replace("usage_",""))
        const wasChecked = lesusages.find(u => u.id === theId)?.selected
        console.log("EVT: "+evt.target.name+" theId: "+theId+" wasChk: "+wasChecked)
/*        console.log("id_usage => poste: "+usages.find(u => Number(u.id) === theId)?.id_poste)
        console.log("LESusage => poste: "+lesusages.find(u => u.id === theId)?.id_poste)*/
        const nextUsages = lesusages.map(usage => {
            if (usage.id === theId) {
                console.log("usage trouvé: "+theId+" "+usage.id+" "+usage.name)
                return { ...usage, selected: !wasChecked };
//                return { ...usage, selected: !!!usage.selected };
            } else { return usage; }
        });
        setlesUsages(nextUsages);
        const posteId = lesusages.find(u => u.id === theId)?.id_poste
        console.log("POSTE visé: "+posteId)
        if(posteId !== undefined) {
            const nextPostes = lespostes.map(poste => {
                if (poste.id === posteId) {
                    console.log("poste trouvé: "+theId+" "+poste.id+" "+poste.name+" interValue: "+checkUsagesChk(posteId))
                    return { ...poste, intermediate: wasChecked };
                    //return { ...poste, intermediate: checkUsagesChk(posteId) };
                } else { return poste; }
            });
            setlesPostes(nextPostes);
        }
    }
    const checkUsagesChk = (id_poste: number) => {
        let result = lesusages.filter(usage => usage.id_poste === id_poste)
            .some(u => u.selected === false)// ? return true : null)
        //result ===
         return !result
    }
    return (
      <><form onSubmit={onSubmit/*handleSubmit(onSubmit/*handleUpdateContact*//*isEditMode ? handleUpdateContact : handleCreateContact)*/}>
      <Typography
        variant={isMobile ? 'h5' : 'h4'}
        color="secondary"
        style={{ marginRight: '0.2em', marginTop: '1.5rem' }}
      >Usages <SubjectIcon className={classes2.customIcon} />
      </Typography>
      <Table className={classes2.contactDetailsTable}>
      <TableHead>
          <TableRow>
            <TableCell key={'Poste'} align="left"><Link onClick={() => console.log("click")}><CheckBox/>Postes</Link></TableCell>
            <TableCell key={'Usage'} align="left"><Link onClick={() => console.log("click")}><CheckBox/>Usages</Link></TableCell>
          </TableRow>
      </TableHead>
      <TableBody>
        { lespostes.map((p,index)=>
            <TableRow style={{borderBottom: '0.5px', borderBottomStyle: 'double'}}>
            <TableCell style={{display: 'inline-flex', margin: '0.2em 0', minWidth: '18rem'}}>
            <FormControl>
                <FormControlLabel key={"poste_"+(p.id+1)} name={"poste_"+(p.id+1)} id={"poste_"+(p.id+1)} label={p.name} 
                    onChange={handlePosteClick/*posteChkboxHandler*/} //value={dbleSuivi} 
                    control={<Checkbox 
//                        checked={p.selected && !p.intermediate}
                        //indeterminate={!p.selected !== p.intermediate} 
                        indeterminate={p.intermediate/*p.selected === false ? p.intermediate : false*/}//!checkUsagesChk(p.id)}
                        checked={p.selected/*p.intermediate === false ? p.selected : false*/} 
                        inputProps={{ 'aria-label': 'controlled' }}/>} />
            </FormControl>
            </TableCell>
            <TableCell>
            { lesusages.filter((u) => u.id_poste === p.id)?.map((uu) =>
            <><FormControl style={{display: 'block', margin: '0.2em 0'}}>
                <FormControlLabel key={"usage_"+(uu.id)} name={"usage_"+uu.id} id={"usage_"+uu.id} label={uu.name} onChange={handleUsageClick}// value={dbleSuivi} 
                    control={<Checkbox checked={/*p.selected && */uu.selected} inputProps={{ 'aria-label': 'controlled' }}/>} />
                </FormControl></>
            ) }</TableCell></TableRow>) }
      </TableBody>
      </Table>
      <Button
        size="large"
        color="primary"
        variant="contained"
        //fullWidth
        className={classes.submitBtn}
        type="submit"
        disabled={submitLoading}
      >
        Créer contact & logement à la date d'état
      </Button>
        {submitError && (
          <ErrorBox
            errorMsg={submitError}
            clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
        )}
    </form>
    </>
    );
  }
  return (<Paper className={classes3.detailsHeader}>
    <div><Typography
        variant={isMobile ? 'h5' : 'h4'}
        color="secondary"
        style={{ marginRight: '0.2em' }}
    >
      <strong>Export des données d'instrumentation</strong>
    </Typography>
    </div>
    <Divider style={{ margin: '0.5em 0' }} />
    {<UsagesExport/>}
    </Paper>
    );
};

export default DataExport;
